import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

/**
 * @see {@link UpdateSearchFilterCommand}
 */
export interface UpdateSearchFilterCommandProperties extends CommandProperties {
  query: string;
}

/**
 * Command to update database search and filter criteria in the native embed experience.
 *
 * This command allows users to modify search terms,
 * providing real-time database content filtering that maintains state
 * across the embedded database experience.
 *
 * This command is _not_ related to supporting Pages/Whiteboard/parent-content-type's search
 * and it is NOT referring to the filter settings panel options in Databases.
 * Search-filter refers to the ability to type a phrase into Database but rather:
 * {@link https://www.loom.com/share/0128c83164024a9ba7fcfb57bd96e1cd?sid=d9c0657d-acc8-4667-a5e5-aca75765685b}
 */
export const UpdateSearchFilterCommand = createCommand<
  UpdateSearchFilterCommandProperties,
  void
>('update-search-filter-command');
